<script>

    import {slide} from 'svelte/transition';

    let sales = [];

    import {onMount} from "svelte";

    onMount(async () => {
        const res = await fetch('/person.json');
        sales = await res.json();
    });

    function scrollDetail(node) {
        let topdiv=node.parentNode.parentNode.parentNode;
        topdiv.scrollIntoView({ behavior: 'smooth' , block: "end" });
}

</script>

<main>
    {#each sales as sale}
        <div class="card">
            <div class="bg-indigo-200 pt-3 pl-3 pr-3 pb-2 rounded-lg shadow-md">
                <div class="col3row">
                    <div class="hidetitle">
                        REF:
                    </div>
                    <div style="background-color: #274478" class="p2 text-white text-center font-bold">
                        {sale.ref}
                    </div>
                    <div class="hidetitle">
                        GRF:
                    </div>
                    <div class="bg-white pl-2 italic font-bold text-center border-indigo-300 border-2">
                        {sale.grf_pounds}
                    </div>
                    <div class="hidetitle">
                        status:
                    </div>
                    <div style="margin: 0 auto;">
                        <img src="/images/{sale.status}small.png" width="28px" alt="test">
                    </div>
                </div>
                <div class="col2row">
                    <div class="hidden md:block ">
                        LOCATION:
                    </div>
                    <div class="bg-white div pl-2 text-center border-indigo-300 border-b-2 border-l-2 border-r-2">
                        {sale.location}
                    </div>
                    <div class="hidden md:block ">
                        1:
                    </div>
                    <div style="margin: 0 auto;">
                        <p class="font-bold bg-orange-300 pl-2 pr-2">{sale.sortcode.charAt(0)}</p>
                    </div>
                </div>

            </div>

            <div class="summary pl-4 bg-gray-100 cursor-pointer" on:click="{() => sale.hidedetail = !sale.hidedetail}">
                <p class="text-sm leading-tight">{sale.precis}</p>
                <div>

                    {#if sale.hidedetail}
                        <img in:scrollDetail style="margin: auto;" class="transform rotate-180 pt-3" src="/images/down.png" width="24px"
                             height="24px"
                             alt="test">
                    {:else}
                        <img style="margin: auto;" class="pt-3" src="/images/down.png" width="24px" height="24px"
                             alt="test">
                    {/if}
                </div>
            </div>

            {#if sale.hidedetail}
                <div transition:slide="{{ duration: 1000 }}" class="pl-4 pr-4 pb-4">
                    <div class="flex justify-end">
                        <button>Email Interest</button>
                    </div>
                    {@html sale.description}
                </div>
            {/if}

        </div>

    {:else}
        <p> loading....</p>

    {/each}

</main>

<style>

    /*hide on small*/
    @media only screen and (max-width: 768px) {
        div.hidetitle {
            display: none;
        }
    }

    .card {
        border: 1px solid #d1e0e8;
        border-radius: 10px;
        max-width: 400px;
        margin: 8px auto;

    }

    .col3row {
        display: grid;
        grid-template-columns: 100px minmax(100px, auto) 36px;
    }

    .col2row {
        display: grid;
        grid-template-columns: minmax(100px, auto) 36px;

    }

    .summary {
        display: grid;
        grid-template-columns: auto 65px;

    }


    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }


    .hide {
        display: none;
    }

    button {
        display: inline-block;
        background-color: #1a70d8;
        border-radius: 10px;
        border: 4px double #cccccc;
        color: #eeeeee;
        text-align: center;
        font-size: 1rem;
        padding: 5px;
        width: 150px;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        -o-transition: all 0.5s;
        transition: all 0.5s;
        cursor: pointer;
        margin: 5px;
    }
</style>